export const UI_updateOnlyCrossIconReducer = {
  UI_updateOnlyCrossIcon: (state, action) => {
    state.onlyCrossIcon = action.payload;
  },
};
